import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  const THEME_KEY = 'APP_THEME'
  const themes = {
    light: 'light',
    dark: 'dark',
    green: 'green',
    blue: 'blue'
  }

  // 获取存储的主题或默认为亮色主题
  const storedTheme = localStorage.getItem(THEME_KEY) 
  const currentTheme = ref(storedTheme || themes.light)
  
  // 是否是深色模式
  const isDarkMode = ref(currentTheme.value === themes.dark)

  // 设置主题
  const setTheme = (theme) => {
    currentTheme.value = theme
    localStorage.setItem(THEME_KEY, theme)
    
    // 更新DOM
    document.documentElement.setAttribute('data-theme', theme)
    
    // 更新深色模式状态
    isDarkMode.value = theme === themes.dark
  }

  // 切换深色/浅色模式
  const toggleDarkMode = () => {
    const newTheme = isDarkMode.value ? themes.light : themes.dark
    setTheme(newTheme)
  }

  // 监听系统主题变化
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)')
  const handleSystemThemeChange = () => {
    if (prefersDark.matches) {
      setTheme(themes.dark)
    } else {
      setTheme(themes.light)
    }
  }

  // 跟随系统主题
  const followSystemTheme = () => {
    handleSystemThemeChange()
    prefersDark.addEventListener('change', handleSystemThemeChange)
  }

  // 停止跟随系统主题
  const stopFollowingSystemTheme = () => {
    prefersDark.removeEventListener('change', handleSystemThemeChange)
  }

  // 初始化主题
  const initTheme = () => {
    setTheme(currentTheme.value)
  }

  return {
    currentTheme,
    isDarkMode,
    themes,
    setTheme,
    toggleDarkMode,
    followSystemTheme,
    stopFollowingSystemTheme,
    initTheme
  }
}) 